import React from 'react';

const TermsCard = ({ terms }) => {
  if (!terms) return null;

  return (
    <div className="ticket-card ticket-terms-section">
      <h4 className="ticket-terms-title">Terms and Conditions</h4>
      <p className="ticket-terms-text">{terms}</p>
    </div>
  );
};

export default TermsCard;
